import Header from "./Header";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {fetchManuscriptsHomeContent} from "../service/ManuscriptService";
import Loading from "./Loading";

function Home() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [totalSubmissions, setTotalSubmissions] = useState(0);
    const [pendingReview, setPendingReview] = useState(0);
    const [averageNoveltyScore, setAverageNoveltyScore] = useState(null);

    useEffect(() => {
        setLoading(true);
        fetchManuscriptsHomeContent(true)
            .then(response => {
                if (response) {
                    setTotalSubmissions(response.totalSubmissions);
                    setPendingReview(response.pendingReview);
                    setAverageNoveltyScore(response.averageNoveltyScore);
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, [])

    return (
        <div>
            <Header page={"upload"}/>
            {loading ? (
                <Loading />
            ) : (
            <div className={"body"}>
                <div className={"dashboard-rows"}>
                    <div className={"dashboard-row-entry"}>
                        <div className={"dashboard-row-entry-number"}>{totalSubmissions}</div>
                        <div className={"dashboard-row-entry-label"}>Total Submissions</div>
                    </div>
                    <div className={"dashboard-row-entry"}>
                        <div className={"dashboard-row-entry-number"}>{pendingReview}</div>
                        <div className={"dashboard-row-entry-label"}>Pending Review</div>
                    </div>
                    <div className={"dashboard-row-entry"}>
                        <div className={"dashboard-row-entry-number"}>{averageNoveltyScore != null ? averageNoveltyScore : '?'}</div>
                        <div className={"dashboard-row-entry-label"}>Average Score</div>
                    </div>
                </div>
                <button className={"upload hover-grey"} onClick={() => navigate("/upload-single")}>+ Upload Single Manuscript</button>
                <button className={"upload hover-grey"} onClick={() => navigate("/upload-batch")}>+ Upload Batch</button>
                <button className={"upload hover-grey"} onClick={() => navigate("/submissions")}>View Submissions</button>
                {/*<div className={"dashboard-row"}>*/}
                {/*    <div className={"submissions-icon"}><PiFoldersFill/></div>*/}
                {/*    <div className={"dashboard-row-entry-number"}>View Submissions</div>*/}
                {/*</div>*/}
                {/*<div className={"search-bar-wrapper dashboard-row"}>*/}
                {/*    <div className={"submissions-input-half submissions-input-half-first"}>*/}
                {/*        <span className={"dropdown-text"}>Latest</span>*/}
                {/*        <span className={"chevron"}><ChevronDown/></span>*/}
                {/*    </div>*/}
                {/*    <div className={"submissions-input-half"}>*/}
                {/*        <span className={"dropdown-text"}>By Score</span>*/}
                {/*        <span className={"chevron"}><ChevronDown/></span>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="search-bar-wrapper dashboard-row">*/}
                {/*    <Search className="search-icon" size={20}/>*/}
                {/*    <input*/}
                {/*        onClick={() => navigate("/submissions")} //todo - remove this (probably)*/}
                {/*        type="text"*/}
                {/*        className="search-bar"*/}
                {/*        placeholder="Search Archive"*/}
                {/*        // value={searchTerm}*/}
                {/*        // onChange={(e) => {*/}
                {/*        //     setSearchTerm(e.target.value);*/}
                {/*        //     setCurrentPage(1);*/}
                {/*        // }}*/}
                {/*    />*/}
                {/*    /!*{searchTerm && (*!/*/}
                {/*    /!*    <button className="clear-search" onClick={() => setSearchTerm("")}>*!/*/}
                {/*    /!*        ×*!/*/}
                {/*    /!*    </button>*!/*/}
                {/*    /!*)}*!/*/}
                {/*</div>*/}
                {/*<div className={"dashboard-row"}>*/}
                {/*    <div className={"submissions-icon"}><PiNotePencilBold/></div>*/}
                {/*    <div className={"dashboard-row-entry-number"}>Decisions</div>*/}
                {/*</div>*/}
                {/*<div className="decision dashboard-row">*/}
                {/*    <span className={"decision-entry"}>*/}
                {/*        <span className={"decision-entry-number"}>(3) </span>*/}
                {/*        <span className={"decision-entry-text"}>Flagged for Review</span>*/}
                {/*    </span>*/}
                {/*    <span className={"chevron chevron-right"}><ChevronRight/></span>*/}
                {/*</div>*/}
                {/*<div className="decision dashboard-row">*/}
                {/*    <span className={"decision-entry"}>*/}
                {/*        <span className={"decision-entry-number"}>(12) </span>*/}
                {/*        <span className={"decision-entry-text"}>Saved Decisions</span>*/}
                {/*    </span>*/}
                {/*    <span className={"chevron chevron-right"}><ChevronRight/></span>*/}
                {/*</div>*/}
            </div>
                )}
        </div>
    )

}

export default Home;